module.exports = __webpack_public_path__ + "static/media/sparkLogo.43512850.svg";